<template>
    <div class="container">
        <el-empty v-if="equipmentList.length == 0" description="暂无数据"></el-empty>
        <el-row :gutter="50" type="flex" style="flex-wrap: wrap;" v-else>
            <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="(item, index) in equipmentList" :key="item + index + 'a'">
                <equipment-card
                    :equipment="item"
                    action-label="立即咨询"
                    full-card-clickable
                    @details="toDetail"
                    @action="qrcodeVisible = true"
                >
                    <template slot="metrics">
                        <div class="otherNums">
                            <span>{{ item.manufacturer }}</span>
                        </div>
                        <div class="otherNums">
                            <span>已咨询</span>
                            <span class="numsColor">{{ item.frequency }}</span>
                            <span>次</span>
                            <span style="margin-left: 10px;">价格：</span>
                            <span class="numsColor" v-if="item.quotationType">￥{{ item.price }}</span>
                            <span class="numsColor" v-else>面议</span>
                        </div>
                    </template>
                </equipment-card>
            </el-col>
        </el-row>
        <div class="pagination">
            <el-pagination
              v-if="total > 0"
              background 
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[8, 16, 24, 32, 40]"
              :current-page="queryParams.pageNum"
              :page-size="queryParams.pageSize"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
        </div>

        <el-dialog title="" :visible.sync="qrcodeVisible" width="400px" append-to-body>
            <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                <img style="width: 250px" src="https://pstatic.navi-sci.cn/%E5%BA%84%E4%B8%BA%281%29.png" />
                <div>扫描二维码添加客服</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { useGetEquipmentMall } from '@/api/request';
import equipmentCard from "@/components/equipmentCard.vue";

export default {
    components: {
        equipmentCard
    },
    data() {
        return {
            qrcodeVisible: false,
            equipmentList: [],
            queryParams: {
                status: 1,
                pageNum: 1,
                pageSize: 8,
            },
            total: 0,
        }
    },
    created() {
        this.getList()
    },
    methods: {
        async getList() {
            const res = await useGetEquipmentMall(this.queryParams)
            this.total = res.total
            this.equipmentList = res.rows
        },
        toDetail(data) {
            this.$router.push({
                name: 'equipmentMallDetail',
                params: {
                    data: JSON.stringify(data)
                }
            })
        },
        handleSizeChange(e) {
            this.queryParams.pageSize = e
            this.getList()
        },
        handleCurrentChange(e) {
            this.queryParams.pageNum = e
            this.getList()
        },
    }
}
</script>

<style lang="scss" scoped>
.container {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 80%;
    min-height: 60vh;
    margin: 0 auto;
    padding: 15px;
}

.pagination {
    display: flex;
    justify-content: flex-end;
}

</style>